// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard_zoomer__uXCvV .dashboard_title__0u5VJ {
  display: none;
  transition: all 1s ease-in-out;
}
.dashboard_zoomer__uXCvV:hover {
  z-index: 100;
}
.dashboard_zoomer__uXCvV:hover .dashboard_title__0u5VJ {
  display: block;
}

.dashboard_headerImage__hcNmC {
  min-height: 120px;
  max-height: 30%;
}
@media (max-width: 640px) {
  .dashboard_headerImage__hcNmC {
    background-position-y: 100px !important;
  }
}
@media (min-width: 640px) {
  .dashboard_headerImage__hcNmC {
    min-height: 240px;
  }
}
@media (min-width: 768px) {
  .dashboard_headerImage__hcNmC {
    min-height: 360px;
  }
}
@media (min-width: 1024px) {
  .dashboard_headerImage__hcNmC {
    min-height: 600px;
  }
}

.dashboard_spacer__FLfek {
  min-height: 150px;
  max-height: 30%;
}
@media (max-width: 640px) {
  .dashboard_spacer__FLfek {
    min-height: 400px;
  }
}
@media (min-width: 640px) {
  .dashboard_spacer__FLfek {
    min-height: 220px;
  }
}
@media (min-width: 768px) {
  .dashboard_spacer__FLfek {
    min-height: 320px;
  }
}
@media (min-width: 1024px) {
  .dashboard_spacer__FLfek {
    min-height: 500px;
  }
}

.dashboard_itemsRow__x4gM5 {
  min-height: 100px;
  max-height: 30%;
}
@media (min-width: 640px) {
  .dashboard_itemsRow__x4gM5 {
    min-height: 140px;
  }
}
@media (min-width: 768px) {
  .dashboard_itemsRow__x4gM5 {
    min-height: 200px;
  }
}
@media (min-width: 1024px) {
  .dashboard_itemsRow__x4gM5 {
    min-height: 300px;
  }
}

.dashboard_itemInRow__jPi-Y {
  height: 120px;
  width: 212px;
}
@media (min-width: 640px) {
  .dashboard_itemInRow__jPi-Y {
    height: 140px;
    width: 247px;
  }
}
@media (min-width: 768px) {
  .dashboard_itemInRow__jPi-Y {
    height: 160px;
    width: 283px;
  }
}
@media (min-width: 1024px) {
  .dashboard_itemInRow__jPi-Y {
    height: 195px;
    width: 345px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/modules/dashboard/index.module.scss"],"names":[],"mappings":"AACI;EACI,aAAA;EACA,8BAAA;AAAR;AAGI;EACI,YAAA;AADR;AAGQ;EACI,cAAA;AADZ;;AAMA;EACI,iBAAA;EACA,eAAA;AAHJ;AAKI;EAJJ;IAKQ,uCAAA;EAFN;AACF;AAKI;EATJ;IAUQ,iBAAA;EAFN;AACF;AAKI;EAdJ;IAeQ,iBAAA;EAFN;AACF;AAKI;EAnBJ;IAoBQ,iBAAA;EAFN;AACF;;AAKA;EACI,iBAAA;EACA,eAAA;AAFJ;AAII;EAJJ;IAKQ,iBAAA;EADN;AACF;AAII;EATJ;IAUQ,iBAAA;EADN;AACF;AAII;EAdJ;IAeQ,iBAAA;EADN;AACF;AAII;EAnBJ;IAoBQ,iBAAA;EADN;AACF;;AAIA;EACI,iBAAA;EACA,eAAA;AADJ;AAII;EALJ;IAMQ,iBAAA;EADN;AACF;AAII;EAVJ;IAWQ,iBAAA;EADN;AACF;AAII;EAfJ;IAgBQ,iBAAA;EADN;AACF;;AAIA;EACI,aAAA;EACA,YAAA;AADJ;AAII;EALJ;IAMQ,aAAA;IACA,YAAA;EADN;AACF;AAII;EAXJ;IAYQ,aAAA;IACA,YAAA;EADN;AACF;AAII;EAjBJ;IAkBQ,aAAA;IACA,YAAA;EADN;AACF","sourcesContent":[".zoomer {\n    .title {\n        display: none;\n        transition: all 1s ease-in-out;\n    }\n\n    &:hover {\n        z-index: 100;\n\n        .title {\n            display: block;\n        }\n    }\n}\n\n.headerImage {\n    min-height: 120px;\n    max-height: 30%;\n\n    @media (max-width: 640px) {\n        background-position-y: 100px !important;\n    }\n\n    // For very small devices and above\n    @media (min-width: 640px) {\n        min-height: 240px;\n    }\n\n    // For medium size devices and above\n    @media (min-width: 768px) {\n        min-height: 360px;\n    }\n\n    // For large size devices and above\n    @media (min-width: 1024px) {\n        min-height: 600px;\n    }\n}\n\n.spacer {\n    min-height: 150px;\n    max-height: 30%;\n\n    @media (max-width: 640px) {\n        min-height: 400px;\n    }\n\n    // For very small devices and above\n    @media (min-width: 640px) {\n        min-height: 220px;\n    }\n\n    // For medium size devices and above\n    @media (min-width: 768px) {\n        min-height: 320px;\n    }\n\n    // For large size devices and above\n    @media (min-width: 1024px) {\n        min-height: 500px;\n    }\n}\n\n.itemsRow {\n    min-height: 100px;\n    max-height: 30%;\n\n    // For very small devices and above\n    @media (min-width: 640px) {\n        min-height: 140px;\n    }\n\n    // For medium size devices and above\n    @media (min-width: 768px) {\n        min-height: 200px;\n    }\n\n    // For large size devices and above\n    @media (min-width: 1024px) {\n        min-height: 300px;\n    }\n}\n\n.itemInRow {\n    height: 120px;\n    width: 212px;\n\n    // For very small devices and above\n    @media (min-width: 640px) {\n        height: 140px;\n        width: 247px;\n    }\n\n    // For medium size devices and above\n    @media (min-width: 768px) {\n        height: 160px;\n        width: 283px;\n    }\n\n    // For large size devices and above\n    @media (min-width: 1024px) {\n        height: 195px;\n        width: 345px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"zoomer": `dashboard_zoomer__uXCvV`,
	"title": `dashboard_title__0u5VJ`,
	"headerImage": `dashboard_headerImage__hcNmC`,
	"spacer": `dashboard_spacer__FLfek`,
	"itemsRow": `dashboard_itemsRow__x4gM5`,
	"itemInRow": `dashboard_itemInRow__jPi-Y`
};
export default ___CSS_LOADER_EXPORT___;
